module.exports = __webpack_public_path__ + "img/marblue.d83b7ca6.jpg";